<template>
	<div>
		<b-container class="bv-example-row">
			<b-row class="justify-content-md-center mt-xl"><b-alert show variant="danger" v-if="error_msg.length>0">{{error_msg}}</b-alert></b-row>
			<b-row class="justify-content-md-center">
				<h3 class="col-md-4 text-center">DYO - Admin Panel</h3>
			</b-row>
			<b-row class="justify-content-md-center">
				<b-card header-tag="header" footer-tag="footer" class="mb-0 pl-0 pr-0 col-md-4">
					<b-card-text>
						<h3 class="mb-0 f-b">Login</h3>
						<p class="font-sm mt-0">Access the dashboard with your credentials.</p>
						<form v-on:keyup.enter="login()">
							<p>
								<label class="f-n mb-1">Email address <span style="color:#FF0000">*</span></label>
								<b-form-input v-model="email" type="email"></b-form-input>
							</p>
							<p>
								<label class="f-n mb-1">Password <span style="color:#FF0000">*</span></label>
								<b-form-input v-model="password" type="password"></b-form-input>
							</p>
						</form>
					</b-card-text>
					<b-button href="#" class="btn w-100 mb-2" @click="login()">Login</b-button>
					<b-link v-if="$root.ACTYPE=='MU'">Fotgot Password?</b-link>
				</b-card>
			</b-row>
			<div class="mt-2 text-center" v-if="$root.ACTYPE=='MU'">
				<b-link>Dont have an account? <b>Sign up</b></b-link>
			</div>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'Login',
	beforeCreate: function() {
        document.body.className = 'login';
    },
	components: {
	},
	created(){
		if(this.$session.get('access_key')){
			this.$router.push('/dashboard');
		}
	},
	data() {
		return{
			email: '',
			password: '',
			error_msg: '',
			url: this.$root.WEBAPI+'login'
		};
	},
	methods: {
		login(){
			var self = this;
			self.axios.post(self.url, {
				email: self.email,
				pass: self.password
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.error_msg = '';
					self.$session.start();
					self.$session.set('access_key', response.data.result.access_key);

					var user_info = response.data.result;
					user_info.options = JSON.parse(response.data.result.options);

					//user_info.options = JSON.parse(user_info.options);
					//console.log(JSON.stringify(user_info));

					self.$root.UNIQID = 15;

					self.$session.set('user_info', user_info);

					self.$root.access_key = response.data.result.access_key;
					self.$router.push('/dashboard')
				}else{
					self.error_msg = response.data.message;
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		}
	}
}
</script>